import { Theme } from "@mui/material";

export const getMeterTableV2Styles = (theme: Theme) => ({
  // Main container styles
  rootContainer: {
    overflowY: "auto",
    backgroundColor: theme.palette.background.paper,
    marginRight: theme.spacing(-2),
    marginLeft: theme.spacing(-2),
  },
  // Title styles
  title: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(-20),
    color: theme.palette.text.primary,
  },
  // Inner container styles
  innerContainer: {
    flex: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  // Filter toggle styles
  filterToggle: {
    display: "flex",
    justifyContent: "flex-end",
    mt: theme.spacing(2),
    mr: theme.spacing(1),
  },
  // Filter button styles
  filterButton: {
    alignItems: "center",
    gap: theme.spacing(1),
    backgroundColor: theme.palette.background.default,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    px: theme.spacing(2),
    py: theme.spacing(1.5),
    mb: theme.spacing(2),
    cursor: "pointer",
  },
  // Filter text styles
  filterText: {
    color: theme.palette.text.primary,
    fontSize: 14,
    fontWeight: 500,
  },
  // Pagination styles
  pagination: {
    mt: theme.spacing(3),
    justifyContent: "center",
    alignItems: "center",
  },
  // Page number styles
  pageNumber: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.common.white,
    px: theme.spacing(2),
    py: theme.spacing(0.5),
    borderRadius: theme.shape.borderRadius,
  },
  // Global body styles
  globalBody: {
    body: {
      fontFamily: "'Mukta', sans-serif",
      fontSize: "13px",
      backgroundColor: theme.palette.background.default,
      color: theme.palette.text.primary,
    },
    "::-webkit-scrollbar": {
      width: "8px",
      height: "8px",
    },
    "::-webkit-scrollbar-track": {
      background: theme.palette.background.paper,
    },
    "::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.grey[800],
      borderRadius: theme.shape.borderRadius,
    },
    "::-webkit-scrollbar-thumb:hover": {
      backgroundColor: theme.palette.grey[700],
    },
  },
});
